import { render, staticRenderFns } from "./marketModal.vue?vue&type=template&id=1676a195&scoped=true&"
import script from "./marketModal.vue?vue&type=script&lang=js&"
export * from "./marketModal.vue?vue&type=script&lang=js&"
import style0 from "./marketModal.vue?vue&type=style&index=0&id=1676a195&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676a195",
  null
  
)

export default component.exports